import { useState, useEffect } from "react";
import { Phone } from "lucide-react";

const PHONE_NUMBER = "tel:+493916357115";

export const StickyMobileButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show button after scrolling past hero section
      if (currentScrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      
      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY) {
        setIsScrollingUp(false);
      } else {
        setIsScrollingUp(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Only show on mobile
  if (typeof window !== 'undefined' && window.innerWidth > 768) {
    return null;
  }

  return (
    <a
      href={PHONE_NUMBER}
      className={`fixed bottom-4 left-4 right-4 z-50 md:hidden flex items-center justify-center gap-3 bg-primary text-white font-semibold py-4 px-6 rounded-xl shadow-2xl transition-all duration-300 ${
        isVisible && isScrollingUp
          ? "translate-y-0 opacity-100"
          : "translate-y-24 opacity-0"
      }`}
      style={{
        boxShadow: "0 10px 40px -10px hsl(210 85% 45% / 0.5)"
      }}
    >
      <Phone className="h-5 w-5" />
      <span>Jetzt anrufen: 0391 635 771 15</span>
    </a>
  );
};

export default StickyMobileButton;
